module.exports = __webpack_public_path__ + "static/media/ciniphilia_react_payment.cb8f88ea.gif";